import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { FC } from 'react'
import { MergedStoreCategoryCardProps } from './CategoryCard.types'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { useRouter } from 'next/router'
import Image from 'next/image'
import events from '@dtx-company/inter-app/src/event-tracking/events/printStore'
import styled from 'styled-components'

export const ImageWrapper = styled(Box)`
  img {
    border-radius: 9px 9px 0px 0px;
  }
`

export const CardWrapper = styled(Box)`
  :hover {
    box-shadow: 3px 3px 30px 0px rgba(17, 17, 17, 0.1);
  }
`

export const MergedStoreCategoryCard: FC<MergedStoreCategoryCardProps> = ({
  isDisabled,
  cardImageUrl,
  cardTitle,
  description,
  id
}) => {
  const router = useRouter()
  const { batchId } = router.query

  const onClick = (): void => {
    events.Flowcode_Store_Categories_Clicked_Category_Card({ id, name: cardTitle })
    const pathname = `${Routes.MERGED_STORE_PRODUCTS}`
    router.push({
      pathname,
      query: {
        category: cardTitle?.toLowerCase(),
        id,
        ...(batchId && {
          batchId
        })
      }
    })
  }

  return (
    <CardWrapper
      flexDirection="column"
      borderRadius="9px"
      width={'100%'}
      height="300px"
      cursor={isDisabled ? 'auto' : 'pointer'}
      data-testid={`card-${id}`}
      onClick={onClick}
      tabIndex={0}
    >
      <Box display="block">
        <ImageWrapper
          height={{ _: '172px', lg: '144px', xl: '172px' }}
          display="block"
          position={'relative'}
        >
          {cardImageUrl && (
            <Image
              layout="fill"
              src={cardImageUrl}
              alt={cardTitle ?? 'flowcode print category'}
              objectFit="cover"
            />
          )}
        </ImageWrapper>
      </Box>
      <Box
        padding="22px 16px 12px"
        height="100%"
        flexDirection="column"
        borderWidth={'0 1px 1px'}
        borderStyle="solid"
        borderColor="secondary.border"
        borderRadius="0 0 9px 9px"
        backgroundColor={'primary.white'}
      >
        <Text fontSize={'16px'} fontWeight={600}>
          {cardTitle}
        </Text>
        <Spacer mb="8px" />
        <Text>{description}</Text>
      </Box>
    </CardWrapper>
  )
}
